export const classes = {
  toggleBlock: 'mx-2 py-1',
  option: 'py-0.5 px-3',
};
